<template>
  <div>
    <HomeHeader />
    <Regions />
    <Footer />
    <div class="stepper-popup" id="stepper-popup">
      <div class="stepper-popup__content">
        <a
          href="#section-regions"
          class="stepper-popup__close"
          @click="resetStepper"
          >&times;</a
        >
        <Stepper ref="stepper" />
      </div>
    </div>
  </div>
</template>

<script>
import HomeHeader from "./HomeHeader.vue";
import Regions from "./Regions.vue";
import Footer from "../UI/Footer.vue";
import Stepper from "../UI/Stepper.vue";

export default {
  components: {
    HomeHeader,
    Regions,
    Footer,
    Stepper
  },
  methods: {
    resetStepper() {
      this.$refs.stepper.reset();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/_variables.scss";
@import "../../sass/_mixins.scss";

.stepper-popup {
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba($color-black, 0.8);
  z-index: 9999;
  opacity: 0;
  visibility: hidden;
  transition: all 0.5s;

  &:target {
    opacity: 1;
    visibility: visible;
  }

  &:target &__content {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }

  &__close {
    &:link,
    &:visited {
      color: $color-white;
      position: absolute;
      top: 1.5rem;
      right: 2.5rem;
      font-size: 3rem;
      text-decoration: none;
      display: inline-block;
      transition: all 0.2s;
      line-height: 1;
      z-index: 10;
    }

    &:hover {
      color: $color-tertiary;
    }
  }

  &__content {
    @include absCenter;
    width: 40%;
    height: 50rem;
    background-image: linear-gradient(
      to right bottom,
      $color-primary-light,
      $color-primary-dark
    );
    color: $color-white;
    box-shadow: 0 2rem 4rem rgba($color-black, $alpha: 0.2);
    border-radius: 0.3rem;
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.5);
    transition: all 0.7s 0.2s;
    position: relative;
  }
}
</style>
